import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { default as i18next } from '../../../../../i18n';
import { LoginContainer } from '../../ReportingLoginContainer/ReportingLoginContainer';
import {
  Heading,
  IconContainer,
  ResultDescription,
  StyledLink,
} from '../ReportingForgotPassword.styles';

interface Params {
  isSuccess: boolean;
  email: string;
}

export const ReportingSendEmailResult = ({ isSuccess, email }: Params) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  const linkComponentToBeEmbedded = (
    <StyledLink to={'/reporting/login'} size="medium" rel="no-referrer" />
  );

  const emailComponentToBeEmbedded = (
    <StyledLink
      href="mailto:techsupport@vaultplatform.com"
      size="medium"
      target="_blank"
      rel="no-referrer"
    />
  );
  const heading = isSuccess
    ? t('reporting.ReportingForgotPassword.sendLinkSuccess')
    : t('reporting.ReportingForgotPassword.sendLinkFailure');
  const description = isSuccess ? (
    t('reporting.ReportingForgotPassword.sendLinkSuccessDescription', {
      email,
    })
  ) : (
    <Trans
      i18n={i18next}
      i18nKey="reporting.ReportingForgotPassword.sendLinkFailureDescription"
      components={{
        a: linkComponentToBeEmbedded,
        mailto: emailComponentToBeEmbedded,
      }}
    />
  );

  return (
    <LoginContainer>
      <IconContainer>
        <img src={emptyStateSrc} alt="Empty state" width="100%" />
      </IconContainer>
      <Heading data-testid="reporting-send-email-result-heading">
        {heading}
      </Heading>
      <ResultDescription data-testid="reporting-send-email-result-description">
        {description}
      </ResultDescription>
    </LoginContainer>
  );
};
